import {
  all, fork, takeEvery, takeLatest, put, call, delay,
} from 'typed-redux-saga';
import { POLL_SYNCSTATUS_DELAY } from '../../constants';
import { TopicApi } from '../../services/topicApi';
import {
  CreateTopicAction,
  CREATE_TOPIC,
  CREATE_TOPIC_SUCCEEDED,
  CREATE_TOPIC_FAILED,
  FETCH_TOPICS,
  FETCH_TOPICS_SUCCEEDED,
  FETCH_TOPICS_FAILED,
  UpdateTopicAction,
  UPDATE_TOPIC_SUCCEEDED,
  UPDATE_TOPIC_FAILED,
  UPDATE_TOPIC,
  DeleteTopicAction,
  DELETE_TOPIC_SUCCEEDED,
  DELETE_TOPIC_FAILED,
  DELETE_TOPIC,
  FETCH_SYNONYMS,
  FETCH_SYNONYMS_SUCCEEDED,
  FETCH_SYNONYMS_FAILED,
  FETCH_ANTONYMS_SUCCEEDED,
  FETCH_ANTONYMS_FAILED,
  FETCH_ANTONYMS,
  POLL_SYNCSTATUS,
  POLL_SYNCSTATUS_SUCCEEDED,
  POLL_SYNCSTATUS_FAILED,
  SYNC_TOPICS,
  SYNC_TOPICS_SUCCEEDED,
  SYNC_TOPICS_FAILED,
  CREATE_SYNONYM,
  CreateSynonymAction,
  CREATE_SYNONYM_SUCCEEDED,
  CREATE_SYNONYM_FAILED,
  CREATE_ANTONYM,
  CreateAntonymAction,
  Term,
  CREATE_ANTONYM_SUCCEEDED,
  CREATE_ANTONYM_FAILED,
} from './types';

function* watchCreateTopic() {
  yield takeEvery(CREATE_TOPIC, createTopic);
}

function* createTopic(action: CreateTopicAction): any {
  try {
    const topicApi = new TopicApi();
    const topic = yield call(topicApi.createTopic, action.topic);

    yield put({ type: CREATE_TOPIC_SUCCEEDED, topic });
  } catch (error) {
    yield put({ type: CREATE_TOPIC_FAILED, error });
  }
}

function* watchUpdateTopic() {
  yield takeEvery(UPDATE_TOPIC, updateTopic);
}

function* updateTopic(action: UpdateTopicAction): any {
  try {
    const topicApi = new TopicApi();
    const topic = yield call(topicApi.updateTopic, action.topic);

    yield put({ type: UPDATE_TOPIC_SUCCEEDED, topic });
  } catch (error) {
    yield put({ type: UPDATE_TOPIC_FAILED, error });
  }
}

function* watchFetchTopics() {
  yield takeLatest(FETCH_TOPICS, fetchTopics);
}

function* fetchTopics():any {
  try {
    const topicApi = new TopicApi();
    const topics = yield call(topicApi.getTopics);

    yield put({ type: FETCH_TOPICS_SUCCEEDED, topics });
  } catch (error) {
    yield put({ type: FETCH_TOPICS_FAILED, error });
  }
}

function* watchDeleteTopic() {
  yield takeLatest(DELETE_TOPIC, deleteTopic);
}

function* deleteTopic(action: DeleteTopicAction): any {
  try {
    const topicApi = new TopicApi();
    yield call(topicApi.deleteTopic, action.topic);

    yield put({ type: DELETE_TOPIC_SUCCEEDED, topicId: action.topic.topicId });
  } catch (error) {
    yield put({ type: DELETE_TOPIC_FAILED, error });
  }
}

function* watchFetchSynonyms() {
  yield takeLatest(FETCH_SYNONYMS, fetchSynonyms);
}

function* fetchSynonyms():any {
  try {
    const topicApi = new TopicApi();
    const synonyms = yield call(topicApi.getSynonyms);

    yield put({ type: FETCH_SYNONYMS_SUCCEEDED, synonyms });
  } catch (error) {
    yield put({ type: FETCH_SYNONYMS_FAILED, error });
  }
}

function* watchFetchAntonyms() {
  yield takeLatest(FETCH_ANTONYMS, fetchAntonyms);
}

function* fetchAntonyms():any {
  try {
    const topicApi = new TopicApi();
    const antonyms = yield call(topicApi.getAntonyms);

    yield put({ type: FETCH_ANTONYMS_SUCCEEDED, antonyms });
  } catch (error) {
    yield put({ type: FETCH_ANTONYMS_FAILED, error });
  }
}

function* watchPollSyncStatus() {
  yield takeLatest(POLL_SYNCSTATUS, pollSyncStatus);
}

function* pollSyncStatus(): any {
  while (true) {
    try {
      const topicApi = new TopicApi();
      const syncState = yield call(topicApi.pollSyncStatus);

      yield put({ type: POLL_SYNCSTATUS_SUCCEEDED, syncState });
      yield call(delay, POLL_SYNCSTATUS_DELAY);
    } catch (error) {
      yield put({ type: POLL_SYNCSTATUS_FAILED, error });
    }
  }
}

function* watchSyncTopics() {
  yield takeLatest(SYNC_TOPICS, syncTopics);
}

function* syncTopics():any {
  try {
    const topicApi = new TopicApi();
    const requestState = yield call(topicApi.syncTopics);

    yield put({ type: SYNC_TOPICS_SUCCEEDED, requestState });
  } catch (error) {
    yield put({ type: SYNC_TOPICS_FAILED, error });
  }
}

function* watchCreateSynonym() {
  yield takeEvery(CREATE_SYNONYM, createSynonym);
}

function* createSynonym(action: CreateSynonymAction): any {
  try {
    const topicApi = new TopicApi();
    const term = new Term(action.synonym);
    const result = yield call(topicApi.createSynonym, term);
    const synonymTerm = result as Term;
    const synonym = synonymTerm.term;

    yield put({ type: CREATE_SYNONYM_SUCCEEDED, synonym });
  } catch (error) {
    yield put({ type: CREATE_SYNONYM_FAILED, error });
  }
}

function* watchCreateAntonym() {
  yield takeEvery(CREATE_ANTONYM, createAntonym);
}

function* createAntonym(action: CreateAntonymAction): any {
  try {
    const topicApi = new TopicApi();
    const term = new Term(action.antonym);
    const result = yield call(topicApi.createAntonym, term);
    const antonymTerm = result as Term;
    const antonym = antonymTerm.term;

    yield put({ type: CREATE_ANTONYM_SUCCEEDED, antonym });
  } catch (error) {
    yield put({ type: CREATE_ANTONYM_FAILED, error });
  }
}

function* topicsSaga() {
  yield all(
    [
      fork(watchFetchTopics),
      fork(watchCreateTopic),
      fork(watchUpdateTopic),
      fork(watchDeleteTopic),
      fork(watchFetchSynonyms),
      fork(watchFetchAntonyms),
      fork(watchPollSyncStatus),
      fork(watchSyncTopics),
      fork(watchCreateSynonym),
      fork(watchCreateAntonym),
    ],
  );
}

export default topicsSaga;
